import React from 'react';
import { STAGES } from '../data/content';
import { cx } from '../lib/hooks';
import { StageControls, type StageControlsProps } from './StageControls';
export function ExploreHud({
  wide,
  controls
}: {
  wide: boolean;
  controls: StageControlsProps;
}) {
  const stage = STAGES.find(s => s.id === controls.stage) ?? STAGES[0];
  return <aside key={stage.id} className={cx('absolute z-30 overflow-y-auto rounded-2xl border border-white/[0.08] bg-white/[0.04] p-4 shadow-[0_24px_60px_-24px_rgba(0,0,0,0.7)] backdrop-blur-[16px] animate-[fadeUp_0.35s_ease_both]', wide ? 'bottom-[150px] right-5 max-h-[calc(100%-230px)] w-[320px]' : 'bottom-[104px] left-3 right-3 max-h-[40%]')} data-id="element-189" data-mp="3ek965en77neh">
      <div className="flex items-center justify-between text-[11px] font-medium uppercase tracking-[0.08em] text-[#5D6272]" data-id="element-190" data-mp="1bwbo1q9pes3">
        <span data-id="element-191" data-mp="ytd9v8gn2ist">Paused · explore</span>
        <span data-id="element-192" data-mp="u0k0g7a86mae">{stage.short}</span>
      </div>
      <div className="mt-1.5 text-[15px] font-semibold leading-5 text-[#EDEEF2]" data-id="element-193" data-mp="tyqu6t3iy42x">{stage.title}</div>
      <p className="mt-1 text-[12px] leading-[18px] text-[#9A9FB0]" data-id="element-194" data-mp="wzb12unkfp5w">{stage.hint}</p>
      <StageControls {...controls} data-id="element-195" data-mp="11vt51sb2njh6" />
    </aside>;
}